import EvereeViewStore from "./Everee.Store";
import EvereeWorkerManagementStore from "./admin/workers/EvereeWorkerManagement.Store";
import EvereeTimesheetManagementStore from "./admin/timesheets/EvereeTimesheetManagement.Store";
import EvereePayrollOperationsStore from "./admin/operations/EvereePayrollOperations.Store";
import EvereeWorkLocationsStore from "./admin/locations/EvereeWorkLocations.Store";
import EvereeFinancialReportsStore from "./admin/reports/EvereeFinancialReports.Store";
// Profile management stores
import EarningProfilesStore from "./admin/profiles/earnings/EarningProfiles.Store";
import DeductionProfilesStore from "./admin/profiles/deductions/DeductionProfiles.Store";
// LNI management store
import LNICodesStore from "./admin/lni/LNICodes.Store";
// Vending integration store
import VendingIntegrationStore from "./admin/vending/VendingIntegration.Store";
// Bulk paystub store
import BulkPaystubStore from "./admin/bulkpaystubs/BulkPaystub.Store";
// TCP Import store
import TcpImportStore from "./admin/tcp-import/TcpImport.Store";
// TCP CSV Import store
import TcpCsvImportStore from "./admin/tcp-csv-import/TcpCsvImport.Store";
// GL Mapping store
import PayrollGLMappingStore from "./admin/gl-mapping/PayrollGLMapping.Store";
// Leave Balance Migration store
import LeaveBalancesStore from "./admin/leave-balances/LeaveBalances.Store";

const payrollStoreList = [
  // Worker self-service store
  { name: "evereeViewStore", store: EvereeViewStore },
  // Admin stores
  { name: "evereeWorkerManagementStore", store: EvereeWorkerManagementStore },
  { name: "evereeTimesheetManagementStore", store: EvereeTimesheetManagementStore },
  { name: "evereePayrollOperationsStore", store: EvereePayrollOperationsStore },
  { name: "evereeWorkLocationsStore", store: EvereeWorkLocationsStore },
  { name: "evereeFinancialReportsStore", store: EvereeFinancialReportsStore },
  // Profile management stores
  { name: "earningProfilesStore", store: EarningProfilesStore },
  { name: "deductionProfilesStore", store: DeductionProfilesStore },
  // LNI management store
  { name: "lniCodesStore", store: LNICodesStore },
  // Vending integration store
  { name: "vendingIntegrationStore", store: VendingIntegrationStore },
  // Bulk paystub store
  { name: "bulkPaystubStore", store: BulkPaystubStore },
  // TCP Import store
  { name: "tcpImportStore", store: TcpImportStore },
  // TCP CSV Import store
  { name: "tcpCsvImportStore", store: TcpCsvImportStore },
  // GL Mapping store
  { name: "payrollGLMappingStore", store: PayrollGLMappingStore },
  // Leave Balance Migration store
  { name: "leaveBalancesStore", store: LeaveBalancesStore },
];

export default payrollStoreList;
